<div class="wrapper-page-landing">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-6">
        <div class="wrapper-hero-section">
          <div class="wrapper-content-hero-section">
            <span class="title-hero-section">Organizacija rodjendana</span>
            <span class="subtitle-hero-section">Senectus lobortis feugiat lacus turpis. Vitae turpis adipiscing ornare pulvinar hendrerit diam vulputate eu. Purus enim nam pellentesque cursus viverra convallis. Eleifend nisi quis.</span>
          </div>

        </div>
      </div>
      <div class="grid__s-6">
        <div class="wrapper-animation-hero">
          <div class="background-gradient"></div>
          <div class="square1 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/game-room-icon.svg"></div>
          <div class="square2 flex items-center justify-center"></div>
          <div class="square3 flex items-center justify-center"></div>
          <div class="square4 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/catering-icon.svg"></div>
          <div class="square5 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/decoration-icon.svg"></div>
          <div class="square6 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/gifts-icon.svg"></div>
          <div class="square7 flex items-center justify-center"></div>
          <div class="square8 flex items-center justify-center"></div>
          <div class="square9 flex items-center justify-center"></div>
          <div class="square10 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/photographer-icon.svg"></div>
          <div class="square11 flex items-center justify-center">
            <img src="assets/icons/landing/hero-animation/cakes-icon.svg">
          </div>
          <div class="square12 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/animators-icon.svg"></div>
          <!--                    <div class="ball-1">-->
          <!--                        <img src="assets/images/ball-1.png" alt="">-->
          <!--                    </div>-->
          <!--                    <div class="ball-2">-->
          <!--                        <img src="assets/images/ball-2.png" alt="">-->
          <!--                    </div>-->
          <!--                    <div class="ball-3">-->
          <!--                        <img src="assets/images/ball-3.png" alt="">-->
          <!--                    </div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Section categories -->
    <div class="grid">
      <div class="grid__s-12">
        <div class="wrapper-categories-flip-cards">
<!--          TODO Zoca Ovo sam promenio dinamicki da ide stavio sam na flip card overflow: hidden proveri to da se lepse vise slike, milutin treba inicijalno da unes seedere ako nema banner treba da bude neki default banner sa slikama i textom koji treba-->
          <div *ngFor="let banner of banners.A" (mouseenter)="hoveredCategoryBanner = banner" class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img [src]="banner.image.full_path" alt="">
              </div>
              <div class="flip-card-back">
                <img
                  [src]="banner.second_image.full_path"
                  alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-text-categories-card">
            <span class="title-category">{{ hoveredCategoryBanner?.name }}</span>
            <span class="description-category">{{hoveredCategoryBanner?.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Section three steps home page  -->
    <div class="three-steps-home">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title red">
            <h2>Organizacija u <span>par koraka</span></h2>
          </div>
          <div class="wrapper-subtitle">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et</p>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-home-steps">
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration1.svg" alt="">
              <h4>Pronadji <br> mesto i vreme</h4>
              <p>Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices, orci vitae convallis mattis.</p>
            </div>
<!--            <img src="../../../../assets/images/landing/line-step.svg" alt="">-->
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration2.svg" alt="">
              <h4>Naruči <br> tortu i hranu</h4>
              <p>Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices, orci vitae convallis mattis.</p>
            </div>
<!--            <img src="../../../../assets/images/landing/line-step.svg" alt="">-->
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration3.svg" alt="">
              <h4>Poželi želju i <br> <span>slavi lagano!</span></h4>
              <p>Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices, orci vitae convallis mattis.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Buy a gifts section -->
    <div class="buy-a-gifts">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title purple">
            <h2>Kupite<span>poklon</span>kod nas</h2>
            <img src="../../../../assets/icons/landing/icon-title-gift.svg" alt="">
          </div>
        </div>
        <div class="grid__s-6">
          <img src="../../../../assets/icons/landing/illustration/illustration-gift.svg" alt="">
        </div>
        <div class="grid__s-6">
          <div class="wrapper-cards-gifts">
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="">
              <div class="content-text">
                <span class="title-card-gift">Aplikacija je besplatna</span>
                <span class="desc-card-gift">Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices.</span>
              </div>
            </div>
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="">
              <div class="content-text">
                <span class="title-card-gift">Jednostavnija evidnecija vođenja zakazanih termina rođendana</span>
                <span class="desc-card-gift">Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices.</span>
              </div>
            </div>
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="">
              <div class="content-text">
                <span class="title-card-gift">Sigurna naplata</span>
                <span class="desc-card-gift">Aliquam erat volutpat. Integer malesuada turpis id fringilla suscipit. Maecenas ultrices.</span>
              </div>
            </div>
            <div class="wrapper-store-buttons-gifts">
<!--              TODO Zoca ovo sam wrapovao sa a tagom poremetilo je velicinu slike-->
              <div class="wrapper-card-gift">
                <a href="https://apps.apple.com/rs/app/moj-rodjendan/id6741870230">
                  <img src="../../../../assets/icons/landing/app-store-icon.svg" alt="">
                </a>
              </div>
              <div class="wrapper-card-gift">
                <a href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app">
                  <img src="../../../../assets/icons/landing/google-play-icon.svg" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Profit section  -->
  <div class="profit-section">
    <img class="star-purple-profit-section rotating" src="../../../../assets/icons/landing/icon-star-purple.svg" alt="">
    <img class="star-gradient-profit-section" src="../../../../assets/icons/landing/icon-star-gradient.svg" alt="">
    <img class="star-blue-profit-section up-down" src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
    <div class="icon1-blue">
      <img src="../../../../assets/icons/landing/elements/icon1-blue.svg" alt="">
    </div>
    <div class="icon2-blue">
      <img src="../../../../assets/icons/landing/elements/icon2-blue.svg" alt="">
    </div>
    <div class="icon3-blue">
      <img src="../../../../assets/icons/landing/elements/icon3-blue.svg" alt="">
    </div>
    <div class="icon4-blue">
      <img src="../../../../assets/icons/landing/elements/icon4-blue.svg" alt="">
    </div>
    <div class="icon5-blue">
      <img src="../../../../assets/icons/landing/elements/icon5-blue.svg" alt="">
    </div>
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title blue">
            <h2>Naše <span>pogodnosti</span> za vas</h2>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-mockup-section">
            <div class="wrapper-mockup-info">
              <div class="item-mockup-info">
                <span class="title-mockup">Sigurna naplata</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">Mogućnost naplate depozita</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">Aplikacija je besplatna</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
            </div>
            <div class="wrapper-mockup-iphone">
              <img class="main-img-ios-mockup"
                   src="../../../../assets/icons/landing/illustration/iphone-mockup-illustration.svg" alt="">
              <img class="arrow-icon-1" src="../../../../assets/icons/landing/icon-arrow-1.svg" alt="">
              <img class="arrow-icon-2" src="../../../../assets/icons/landing/icon-arrow-2.svg" alt="">
              <img class="arrow-icon-3" src="../../../../assets/icons/landing/icon-arrow-3.svg" alt="">
              <img class="arrow-icon-4" src="../../../../assets/icons/landing/icon-arrow-4.svg" alt="">
              <img class="arrow-icon-5" src="../../../../assets/icons/landing/icon-arrow-5.svg" alt="">
              <img class="arrow-icon-6" src="../../../../assets/icons/landing/icon-arrow-6.svg" alt="">
            </div>
            <div class="wrapper-mockup-info">
              <div class="item-mockup-info">
                <span class="title-mockup">Ne utičemo na cenu</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">Elektronska evidencija i obaveštenja</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">Jednostavnija evidnecija zakazanih termina</span>
                <span class="desc-mockup">Welcome to Burger Bliss, where we take your cravings to a whole new</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Largest business partners section -->
  <div class="zc-container">
    <div class="wrapper_largest_business_partners">
      <div class="grid">
        <div class="grid__s-12">
          <span class="small-title">Najveći biznis partneri</span>
        </div>
      </div>
      <div class="grid">
        <div *ngFor="let partner of businessPartners" class="grid__m-4">
          <a *ngIf="banners.B?.length && banners.B[partner]" [href]="banners.B[partner]?.link" target="_blank">
            <div class="wrapper-banner-image-largest-business">
              <img [src]="banners.B[partner]?.image.full_path" alt="">
            </div>
          </a>
          <div *ngIf="!banners.B?.length || !banners.B[partner]" class="wrapper-banner-empty">
            <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
            <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
            <div class="content-empty-banner">
              <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
              <span>Mesto za</span>
              <span><b>Vašu reklamu!</b></span>
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-become-our-partner">
            <span>Postanite naš partner</span>
            <button [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" class="custom-btn custom-btn--outline">
              <span>Za biznise</span>
              <img src="../../../../assets/icons/landing/arrow-right.svg" alt="">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <div class="wrapper-landing-blogs">
      <div class="grid">
        <div class="grid__s-12">
          <span class="small-title">Zanimljivosti na Blogu</span>
        </div>
      </div>
      <div class="grid">
        <div class="grid__m-4">
          <div class="wrapper-card-blog">
            <div class="wrapper-header-card-blog">
              <img src="../../../../assets/images/landing/blogs/image-blog1.png" alt="">
            </div>
            <div class="wrapper-content-card-blog">
              <div class="zc-d-flex zc-align-items">
                <div class="wrapper-category-label red">
                  <span>Igraonica</span>
                </div>
                <span class="time-card-blog">10 min ago</span>
              </div>
              <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
              <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
              <span class="link-blue-text">Vidi više</span>
            </div>
          </div>
        </div>
        <div class="grid__m-4">
          <div class="wrapper-card-blog">
            <div class="wrapper-header-card-blog">
              <img src="../../../../assets/images/landing/blogs/image-blog2.png" alt="">
            </div>
            <div class="wrapper-content-card-blog">
              <div class="zc-d-flex zc-align-items">
                <div class="wrapper-category-label blue">
                  <span>Torte</span>
                </div>
                <span class="time-card-blog">10 min ago</span>
              </div>
              <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
              <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
              <span class="link-blue-text">Vidi više</span>
            </div>
          </div>
        </div>
        <div class="grid__m-4">
          <div class="wrapper-card-blog">
            <div class="wrapper-header-card-blog">
              <img src="../../../../assets/images/landing/blogs/image-blog3.png" alt="">
            </div>
            <div class="wrapper-content-card-blog">
              <div class="zc-d-flex zc-align-items">
                <div class="wrapper-category-label green">
                  <span>Dekoracija</span>
                </div>
                <span class="time-card-blog">10 min ago</span>
              </div>
              <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
              <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
              <span class="link-blue-text">Vidi više</span>
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <div [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" class="view-more-btn">
            <span>Pogledaj sve</span>
            <img src="../../../../assets/icons/landing/arrow-right.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  User experiences section  -->
  <div class="wrapper-user-experiences-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title user-experience">
            <h2>Iskustva korisnika</h2>
            <img src="../../../../assets/icons/landing/illustration/illustration-user-experiences.svg" alt="">
          </div>
        </div>
        <div *ngIf="userExperiences.length" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[0].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">this.router.url === PAGES_AND_PATHS.landingBlog.pagePath
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[0].image.full_path" alt="">
                <span>{{ userExperiences[0].author }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="userExperiences.length > 1" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[1].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[1].image.full_path" alt="">
                <span>{{ userExperiences[1].author }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="userExperiences.length > 2" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[2].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[2].image.full_path" alt="">
                <span>{{ userExperiences[2].author }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ section -->
  <div class="wrapper-faq-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-faq">
            <div class="social-media-box social-media-box--1">
              <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
            </div>
            <div class="wrapper-title faq">
              <h2>Česta <span>pitanja</span></h2>
              <img src="../../../../assets/icons/landing/illustration/faq-illustration.svg" alt="">
            </div>
            <div class="wrapper-content-faq">
              <div *ngFor="let faq of faqs; index as faqIndex" class="wrapper-question" (click)="faqIndex === activeFaqIndex ? activeFaqIndex = -1 : activeFaqIndex = faqIndex" [ngClass]="{'collapsed': faqIndex === activeFaqIndex}">
                <span class="title-question">{{ faq.question }}</span>
                <span class="description-answer">{{faq.answer}}</span>
                <img class="icon-star-green" src="../../../../assets/icons/landing/icon-star-green.svg" alt="">
                <img class="icon-blue plus" src="../../../../assets/icons/landing/icon-plus-blue.svg" alt="">
                <img class="icon-blue minus" src="../../../../assets/icons/landing/Icon-minus-blue.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section -->
  <div class="wrapper-newsletter">
    <span class="title-newsletter">Treba vam još informacija?</span>
    <span class="subtitle-newsletter">Write your concern to us and our specialist will get back to you.</span>
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitPostNewsletterForm()" class="form-newsletter">
      <div class="wrapper-input-landing">
        <div class="custom-input">
          <input [formControl]="newsletterForm.controls.email | formControl" type="text" placeholder="">
        </div>
        <span class="error-message">{{newsletterForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : newsletterFormTriedToSubmit}}</span>
      </div>
      <button type="submit" class="custom-btn custom-btn--primary">
        <span>Pošaljite</span>
      </button>
    </form>
  </div>
  <div class="moving-tape-section">
    <div class="wrapper-slider-auto">
      <div class="wrapper-slider-image">
        <img *ngFor="let mediumPartnerBanner of banners.C" [src]="mediumPartnerBanner.image.full_path" alt="">
      </div>
      <div class="wrapper-slider-image">
        <img *ngFor="let mediumPartnerBanner of banners.C" [src]="mediumPartnerBanner.image.full_path" alt="">
      </div>

    </div>
  </div>
</div>
